import { useEffect, useState } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import Chat from "./Chat";

const Numbers = () => {
    const [filters, setFilters] = useState({
        client_name: "",
        wa_id: "",
        min_date: "",
        max_date: "",
        status: "",
    });
    const jsonFilters = JSON.stringify(filters);
    const [numbers, setNumbers] = useState(null);
    const [numId, setNumId] = useState(null);
    const [page, setPage] = useState(1);
    const { auth } = useAuth();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        const fetch = async () => {
            try {
                let url = `/numbers?page=${page}&per_page=50&order=desc`;
                const filters = JSON.parse(jsonFilters);
                Object.keys(filters).forEach(key => {
                    if (filters[key]) {
                        url = `${url}&${key}=${filters[key]}`
                    }
                });
                const response = await axiosPrivate.get(url, {headers: {Authorization: "Bearer " + auth.accessToken}});
                setNumbers(response.data);
            } catch(err) {
                console.log(err);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate, page, jsonFilters]);

    const getUrl = (path) => {
        Object.keys(filters).forEach(key => {
            if (filters[key]) {
                const connector = path.includes("?") ? "&" : "?";
                path = `${path}${connector}${key}=${filters[key]}`
            }
        });
        return path
    }

    const download = async () => {
        try {
            let url = getUrl("/numbers_csv");
            const response = await axiosPrivate.get(url, {headers: {Authorization: "Bearer " + auth.accessToken}});
            const href = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", 'numbers.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch(err) {
            console.log(err);
        }
    }

    if (!numbers) {
        return <div>Loading...</div>
    }

    const onChange = (evt) => {
        const {name, value} = evt.target;
        setFilters(curr => ({...curr, [name]: value}));
    }

    return (
        <div>
            <div>
                <div style={{paddingBottom:'2rem'}}>
                    <span className="relative flex justify-center">
                        <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Chats</span>
                    </span>
                </div>
            </div>
            <div style={{display: "grid", rowGap: "1.5rem"}}>
                <div className="bg-blue-200 p-4 rounded-lg">
                    <div>
                        <button style={{color:"#000", background:"#fff"}} className="bg-indigo-400 py-2 px-2 rounded-lg text-xs" onClick={() => download()}>Download Numbers</button>
                    </div>
                </div>
                <div style={{display: "flex", justifyContent: "space-between", padding: "1.5rem"}} className="bg-slate-100 rounded-lg">
                    <div style={{width: "22%"}}>
                        <label htmlFor="client_name" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                name="client_name"
                                placeholder="search by client name"
                                onChange={onChange}
                                value={filters.client_name}
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                                style={{padding: "0.5rem", width: "100%"}}
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Client Name
                            </span>
                        </label>
                    </div>
                    <div style={{width: "22%"}}>
                        <label htmlFor="wa_id" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                name="wa_id"
                                placeholder="search by whatsapp number"
                                onChange={onChange}
                                value={filters.wa_id}
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                                style={{padding: "0.5rem", width: "100%"}}
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Whatsapp Number 
                            </span>
                        </label>
                    </div>
                    <div style={{width: "22%"}}>
                        <label htmlFor="min_date" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="datetime-local"
                                name="min_date"
                                placeholder="min date"
                                onChange={onChange}
                                value={filters.min_date}
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                                style={{padding: "0.5rem", width: "100%"}}
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Min Date 
                            </span>
                        </label>
                    </div>
                    <div style={{width: "22%"}}>
                        <label htmlFor="max_date" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="datetime-local"
                                name="max_date"
                                placeholder="max date"
                                onChange={onChange}
                                value={filters.max_date}
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                                style={{padding: "0.5rem", width: "100%"}}
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Max Date 
                            </span>
                        </label>
                    </div>
                </div>
                <div style={{overflowY: "auto"}}>
                    <div style={{height: "67vh"}}>
                        <div style={{display: "flex", width: "100%", maxWidth: "100%", columnGap: "1%"}}>
                            <div style={{width: "45%"}} >
                                <div style={{overflowY: "auto"}}>
                                    <div style={{height: "65vh"}}>
                                        <table className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm">
                                            <thead className="ltr:text-left rtl:text-right">
                                                <tr className="bg-slate-100 rounded-lg" style={{top: "0", position: "sticky"}}>
                                                    <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Client Name</th>
                                                    <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Status</th>
                                                    <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Title</th>
                                                    <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">WA ID</th>
                                                    <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Created By</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {numbers.numbers.map(number => (
                                                    <tr className={numId === number.id ? "bg-gray-200 cursor-pointer": "odd:bg-gray-50 cursor-pointer"} key={number.id} onClick={() => setNumId(number.id)}>
                                                        <td className="whitespace-nowrap px-4 py-2 text-gray-700">{number.client_name}</td>
                                                        <td className="whitespace-nowrap px-4 py-2 text-gray-700">{number.status}</td>
                                                        <td className="whitespace-nowrap px-4 py-2 text-gray-700">{number.title}</td>
                                                        <td className="whitespace-nowrap px-4 py-2 text-gray-700">{number.wa_id}</td>
                                                        <td className="whitespace-nowrap px-4 py-2 text-gray-700">{number.created_at}</td>
                                                    </tr>
                                                )
                                            )}
                                            </tbody>
                                        </table>
                                        <div className="bg-indigo-500 p-2 rounded-lg" style={{width: "fit-content", position: "absolute", bottom: "4vh"}}>
                                            {page !== 1 ? <button className="text-xs" style={{color: "#fff"}} onClick={() => setPage(curr => curr - 1)}>Back</button> : null}
                                            {numbers.pages > page ? <button className="text-xs" style={{color: "#fff"}} onClick={() => setPage(curr => curr + 1)}>Next</button> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {numId && <Chat key={numId} numId={numId}/>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Numbers;